<template>
  <el-card class="box-card" body-style="padding: 0px">
    <div slot="header" class="clearfix">
      <el-row :gutter="10">
        <el-col :sm="12" :xs="24">
          <!-- <span>{{ this.isValidTitle }}</span> -->
        </el-col>
        <el-col :sm="12" :xs="24" style="text-right">
          <label class="card-title text-left">チャージ会員</label>
        </el-col>
        <el-col :sm="12" :xs="24" style="text-right">
          <el-button class="btn-plus" style="float: right" type="success" icon="el-icon-plus" @click="addCharge" v-if="permission.can('write', 'membershipcharge')" >
            新規登録する
          </el-button>
<!--          <el-button class="btn-plus" style="float: right" type="success">-->
<!--            表示切り替え-->
<!--          </el-button>-->
        </el-col>
      </el-row>
    </div>
    <div class="clearfix">
      <el-table :data="membershipCharges" border fit highlight-current-row style="width: 100%" @row-click="rowClicked" @sort-change="handleSort" empty-text="データはありません。"
      >
        <el-table-column
          prop="member_code"
          label="会員番号"
          min-width="130px"
        >
        </el-table-column>
        <el-table-column
          prop="charge_package.name"
          label="チャージ名"
          min-width="130px"
        >
        </el-table-column>
        <el-table-column
          prop="clinic_customer_note.full_name"
          min-width="130px"
          label="名前"
        >
        </el-table-column>
        <el-table-column
          prop="clinic.clinic_name"
          min-width="130px"
          label="店舗名"
        >
        </el-table-column>
        <el-table-column
          prop="total_point"
          min-width="130px"
          label="チャージポイント"
        >
          <template slot-scope="props">
            {{ props.row.total_point && props.row.total_point.toLocaleString() }}
          </template>>
        </el-table-column>
        <el-table-column
          prop="point_status"
          min-width="130px"
          sortable="custom"
          label="ステータス"
        >
        </el-table-column>
        <el-table-column
          prop="purchase_date"
          min-width="130px"
          sortable="custom"
          label="チャージ日"
        >
        </el-table-column>
        <el-table-column
          prop="expired_date"
          min-width="130px"
          sortable="custom"
          label="直近有効期限"
        >
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import permissionService from "../../services/permission_service";

export default {
    data() {
      return {
        permission: permissionService
      }
    },
    computed: {
      ...mapGetters(['membershipCharges', 'newCharge', 'queryMembershipCharge', 'queryMembershipCharge', 'currentClinic']),
    },
    methods: {
      ...mapMutations('membership_charge', ['SET_IS_CHARGE_VISIBLE', 'SET_MEMBERSHIP_CHARGE_IS_EDIT', 'SET_EDIT_MEMBERSHIP_CHARGE', 'SET_QUERY_MEMBERSHIP_CHARGE']),
      ...mapActions('clinic_customer_note', ['fetchClinicCustomerNotes']),
      ...mapActions('charge_package', ['fetchModalChargePackages']),
      ...mapActions('membership_charge', ['fetchMembershipCharges']),
      async addCharge() {
        this.SET_EDIT_MEMBERSHIP_CHARGE(this.newCharge)
        this.SET_IS_CHARGE_VISIBLE(true)
        this.SET_MEMBERSHIP_CHARGE_IS_EDIT(false)
        if (this.permission.can('write_all', 'membershipcharge')) {
          this.fetchModalChargePackages({type: 'reset'})
        } else if (this.permission.can('write', 'membershipcharge')) {
          await this.fetchClinicCustomerNotes({clinic_id: this.currentClinic.id})
          this.fetchModalChargePackages({clinic_id: this.currentClinic.id})
        }
        document.body.classList.add('modal-open')
      },
      rowClicked(row) {
        this.SET_MEMBERSHIP_CHARGE_IS_EDIT(true)
        this.SET_IS_CHARGE_VISIBLE(true)
        this.SET_EDIT_MEMBERSHIP_CHARGE(row)
        document.body.classList.add('modal-open')
      },
      handleSort(props) {
        if (!props.order) {
          return
        }

        const order = props.order === 'descending' ? props.order.slice(0, 4) : props.order.slice(0, 3)
        this.SET_QUERY_MEMBERSHIP_CHARGE({ order: `${props.prop} ${order}` })
        this.fetchMembershipCharges()
      }
    }
  }
</script>
<style>
  th .cell, .el-table .sort-caret.ascending {
    color: #51cbce;
  }
</style>
